/* eslint-disable */
import styled, { css } from 'styled-components';
import cssKit from '../../css';

export const LoadingSpinnerContainer = styled.div`
  position: relative;
  width: 58px;
  height: 58px;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  ${cssKit.mixins.fadeIn(1)};

  ${(props) => {
    if (props.position === 'absolute') {
      return css`
        position: absolute;
        left: 50%;
        transform: translate(-50% -50%);
      `;
    }
  }};
`;

export const LoadingSpinnerDot = styled.div`
  position: absolute;
  background-color: #f1f1ef;
  width: 14px;
  height: 14px;
  border-radius: 9px;

  animation-name: pulse_dot;
  animation-duration: 1.1s;
  animation-iteration-count: infinite;
  animation-direction: normal;

  @keyframes pulse_dot {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.3);
    }
  }

  &#dot_1 {
    left: 0;
    top: 23px;
    animation-delay: 0.41s;
  }

  &#dot_2 {
    left: 6px;
    top: 6px;
    animation-delay: 0.55s;
  }

  &#dot_3 {
    top: 0;
    left: 23px;
    animation-delay: 0.69s;
  }

  &#dot_4 {
    right: 6px;
    top: 6px;
    animation-delay: 0.83s;
  }

  &#dot_5 {
    right: 0;
    top: 23px;
    animation-delay: 0.97s;
  }

  &#dot_6 {
    right: 6px;
    bottom: 6px;
    animation-delay: 1.1s;
  }

  &#dot_7 {
    left: 23px;
    bottom: 0;
    animation-delay: 1.24s;
  }

  &#dot_8 {
    left: 6px;
    bottom: 6px;
    animation-delay: 1.38s;
  }
`;

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/LoadingSpinner/styles.js
 **/